'use client'

import { useEffect, useState, useMemo } from "react";
import parse from 'html-react-parser';
import { TextAPI } from "@/api/TextAPI";
import styles from './disclaimerAndTrip.module.scss'

const aboutTripTextType = 'tell_us_about_your_trip'
const disclaimerTextType = 'disclaimer'

export default function DisclaimerAndTrip() {

  const [ aboutTripBodyText, setAboutTripBodyText ] = useState("")
  const [ disclaimerBodyText, setDisclaimerBodyText ] = useState("")

  const textAPI = useMemo(() => new TextAPI(process.env.NEXT_PUBLIC_API_BASE_URL ?? ''), [])

  useEffect(() => {
    textAPI.getByType(disclaimerTextType).then(text => text && setDisclaimerBodyText(text.body))
  }, [textAPI])

  useEffect(() => {
    textAPI.getByType(aboutTripTextType).then((text) => {
      text && setAboutTripBodyText(text.body)
    })
  }, [textAPI])


  return (
    <>
    <div className={styles.disclaimer}>
      { parse(disclaimerBodyText) }
    </div>
    <div className={styles.trip}>
      { parse(aboutTripBodyText) }
      <h2>Tell us about your trip!</h2>
      <p>We would love to hear from you, please share your experience with us. <a href="https://www.seaworldparks.co.uk/your-experience" target="_blank" rel="noopener noreferrer">Share</a></p>
    </div>
    </>
  )
}
